import { Component, OnInit, Input, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
// Observable class extensions
import 'rxjs/add/observable/of';

// Observable operators
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { CommonService, ServiceWalkInService, SubscribeService } from '../../../services/index';
import { ServiceEntryModel } from '../../../model/index';

@Component({
    selector: 'add-service-entry-tab',
    templateUrl: './addServiceEntry.component.html'
})
export class AddServiceEntryComponent implements OnInit {
    spareData=[];
    private searchTerms = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }
    // @Input() set clientSearchEmit(val: any[]) {
    //     debugger;
    // }

    statusCusCtrl: FormControl;
    serialNoCtrl: FormControl;
    potCusCtrl: FormControl;
    clientCtrl: FormControl;
    referenceCtrl: FormControl;
    modelCtrl: FormControl;
    sparedet:any;
    branchList: any[] = [];

    locationCtrl: FormControl;
    potCusOptList: any[];
    statusList: any[];
    clientList: any[];
    prodList: any[];
    modelList: any[]=[];
    serialNumberList: any[]=[];
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    salesBillentryDetails = [];
    columns = [];
    newcolumn=[];
    filteredBranch: Observable<any[]>;
    filteredItems: Observable<any[]>;
    filteredReference: Observable<any[]>;
    filteredHA: Observable<any[]>;

    @Input() servicegriddata: ServiceEntryModel[] = [];
    @Input() serviceInData: ServiceEntryModel[] = [];
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('prodAutoComp') prodAutoComp;
    @ViewChild('serialAutoComp') serialAutoComp;
    // @ViewChild('singleClientDetails') singleClientDetails;
    @ViewChild('searchComponent') searchComponent;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    itemList: any[] = [];
    isLoading: boolean = false;
    minDate: any;

    constructor(public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private serviceWalkInService: ServiceWalkInService, public subscribeService: SubscribeService
    ) {
        this.potCusCtrl = new FormControl();
        this.statusCusCtrl = new FormControl();
        //this.serialNoCtrl = new FormControl();
        this.potCusOptList = ['Yes', 'No'];
        this.statusList = ['Yes', 'No'];
        this.getModelList();
        //FOR AUTO COMPLETE VALIDATION --- HA MODEL
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.serialNoCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        this.referenceCtrl = new FormControl();
        this.filteredReference = this.referenceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        this. modelCtrl=new FormControl();   
        this.filteredHA = this.modelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.modelList.slice());
    }

    ngOnInit(): void {
        this.sparedet={
            model_id:'',
            qty:''
        }
        this.serviceInData['from_branch']=this.serviceInData['branch_id'];
        let that = this;
        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'walkIn')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList = res;
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false' });
        });

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model', prop: 'prod_name', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:130,minWidth:130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:130,minWidth:130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology',width:120,minWidth:120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Quantity', prop: 'qty', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Service Amount', prop: 'rate', width: 130, minWidth: 130, maxWidth: 130, sortable: false, cellClass: 'cell-right' },
            { name: 'Amount', prop: 'amount', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.newcolumn = [
            { name: 'Spare Name', prop: 'name',width:330,minWidth:330,maxWidth:330},
            { name: 'Qty', prop: 'qty', width: 150, minWidth: 150, maxWidth: 150 }
        ]
        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());

            this.serviceInData['date'] = new Date();

        }
        this.servicegriddata['wrnty'] = false;
        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
        }
        this.serviceInData['random_no'] = this.getRandomInt(1, 500);
        this.getModelList();

    }

    displayBranch(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }

    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.modelList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }
    displayHa(modelID: any) {
        if (this.modelList != undefined) {
            if (modelID && this.modelList.length > 0) {
                let fitem = _.find(this.modelList, { 'model_id': modelID });
                return fitem['name'];
            }
        }
        return '';

    } 
    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'serviceTrack',
                date: moment(this.serviceInData['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.serviceInData['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            if (mode == 'Edit') {
                let data = this._params;
                this.serviceInData = this._params;
                this.serviceInData['auto_no'] = this._params['bill_no'];
                this.serviceInData['date'] = new Date();
                //this.prodList = this._params['prodRes'];//new Date();
                this.getServiceHaModelDetails(data);
                // this.singleClientDetails.loadClient(this.serviceInData['client_id']);
            }
        }
    }

    getServiceHaModelDetails(data: any): void {
        let that = this,
            params = {
                //bill_id: data.bill_id,
                ser_id: data.ser_id,
                type: 'ServiceTesting'
            };
        this.serviceWalkInService
            .getServiceModelDetails(params)
            .then(function (res: any) {
                that.prodList = res.prodRes;
                // that.page.count = res.totCnt;
                // that.salesBillentryDetails = res.data;
            });
    }
    getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(this.serviceInData['random_no'] + '_' + nextEl))) {
            nextEl = 'followup_status';
        }
        $('#' + this.serviceInData['random_no'] + '_' + nextEl).focus();
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.serviceInData['sale_no'] = fitem.sale_no;
                this.serviceInData['sale_date'] = fitem.sale_date;
                this.serviceInData['item'] = fitem.item;
                this.serviceInData['quantity'] = fitem.quantity;
                this.serviceInData['client_no'] = fitem.client_no;
                this.serviceInData['client_name'] = fitem.client_name;
                this.serviceInData['mobile'] = fitem.mobile; //ANOTHER FIELD
                this.serviceInData['reference_name'] = fitem.reference_name;
                //  this.singleClientDetails.loadClient(fitem);//TO LOAD CLIENT OBJECT
                return fitem['client_no'];
            }

        }
        return '';
    }
    //  for loading the product and qunatity on change function
    displayProd(ser_det_id, qty: any) {
        if (this.prodList != undefined) {
            if (ser_det_id && this.prodList.length > 0) {
                let fitem = _.find(this.prodList, { 'ser_det_id': ser_det_id });
                //TO LOAD CLIENT OBJECT
                return fitem['name'];
            }
            if (ser_det_id && this.prodList.length > 0) {
                let fitem = _.find(this.prodList, { 'qty': qty });
                //TO LOAD CLIENT OBJECT
                return fitem['qty'];
            }

        }
        return '';
    }

    displaySerial( serialNO: any) {
        if (this.serialNumberList != undefined) {
            if (this.serialNumberList.length > 0 && serialNO) {
                let fitem = _.find(this.serialNumberList, { 'serialNO': serialNO  });
                return fitem['serialNO'];
            }
        }
        return serialNO || '';
    }

    onChangeProd(ha: any) {
        let that = this;
        let ser_det_id = ha.ser_det_id;
        let fitem = _.find(this.prodList, { 'ser_det_id': ser_det_id });
        //TO LOAD CLIENT OBJECT
        that.servicegriddata['prod_name'] = fitem['name'];
        that.servicegriddata['model_id'] = fitem['model_id'];
        that.servicegriddata['qty'] = fitem['qty'];
        that.servicegriddata['serial_no'] = fitem['serial_no'];
        that.servicegriddata['sl_old'] = fitem['serial_no'];
        that.servicegriddata['brand_name'] = fitem['brand_name'];
        that.servicegriddata['brand_model_name'] = fitem['brand_model_name'];
        that.servicegriddata['family_name'] = fitem['family_name'];
        that.servicegriddata['series_name'] = fitem['series_name'];
        that.servicegriddata['performance_name'] = fitem['performance_name'];
        that.servicegriddata['power_name'] = fitem['power_name'];
        that.servicegriddata['battery_name'] = fitem['battery_name'];
        that.servicegriddata['color_name'] = fitem['color_name'];
        that.servicegriddata['color_id'] = fitem['color_id'];
        that.servicegriddata['tele_audiology'] = fitem['tele_audiology'];
        that.servicegriddata['brand_id'] = fitem['brand_id'];
        that.servicegriddata['brand_model_id'] = fitem['brand_model_id'];
        that.servicegriddata['family_id'] = fitem['family_id'];
        that.servicegriddata['series_id'] = fitem['series_id'];
        that.servicegriddata['performance_id'] = fitem['performance_id'];
        that.servicegriddata['power_id'] = fitem['power_id'];
        that.servicegriddata['battery_id'] = fitem['battery_id'];
    }

    // end
    resetWalkInData() {
        if (this._params['mode'] == 'Add') {
            this.serviceInData = [];
            this.serviceInData['date'] = new Date();
        }
    }
    /* loadFollowUpStatus(): void {
         let that = this;

         that.commonService
             .getFollowUpStatusList({})
             .then(function(res: any) {
                 that.statusList = res.data;
             });
     }*/
    displayStatusFn(fol_id: any) {
        if (this.statusList != undefined) {
            if (fol_id && this.statusList.length > 0) {
                let folObj = _.find(this.statusList, { 'fol_id': fol_id });
                return folObj['name'];
            }
        }
        return '';
    }


    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayRef(item_id: number) {
        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['prod_name'];
        }
        return '';
    }
    onDeleteSalesbillentry(row: any): void {
        let that = this,
            mode = this._params['mode'];


        if (mode == 'Edit') {
            this.salesBillentryDetails.splice(this.salesBillentryDetails.indexOf(row), 1);
            this.calGrossTotal();
        } else {
            let params = {
                name: row['prod_name'],
                model_id: row['model_id'],
                ser_id: row.ser_id,
            };

            //  this.salesBillgriddata = [];

            // this.serviceEntryService
            //     .deleteGridList(params)
            //     .then(function(res: any) {
            //         that.isLoading = false;
            //         if (res.success) {
            //             that.salesBillentryDetails.splice(that.salesBillentryDetails.indexOf(row), 1);
            //             swal('SUCCESS', res.message, 'success');
            //
            //           // that.getServiceWalkInList();
            //
            //
            //         } else {
            //
            //             swal('ERROR', res.message, 'error');
            //         }
            //     });
        }
    }
    addServiceInentry(): void {

        let that = this,
            mode = this._params['mode'],

            modelID = this.servicegriddata['model_id'],
            modelName = this.servicegriddata['prod_name'];
            this._params['serial_no'] = this.servicegriddata['serial_no'],
            this._params['sl_old'] = this.servicegriddata['sl_old'];

        if(this.servicegriddata['wrnty'] == true) {
            this.servicegriddata['wrnty'] = true
        } else {
            this.servicegriddata['wrnty'] = false
        }

        if (!_.isEmpty(_.toString(modelID))) {//} != undefined) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.salesBillentryDetails, { 'model_id': modelID });

            if (preTestID) {
                swal('WARNING', 'Model : ' + modelName + ' Already Exists');
                return;
            }

            if (_.isEmpty(_.toString(this.servicegriddata['rate']))) {

                swal('WARNING', 'Please Enter ' + modelName + ' Rate');
                return;

            }




            if (mode == 'Edit') {



                let testDet = Object.assign({}, this.servicegriddata);
                this.salesBillentryDetails.push(testDet);
                this.servicegriddata = [];
                this.servicegriddata['amount'] = 0;
                that.page.count = this.salesBillentryDetails.length;
                that.calGrossTotal();
                //this.serialNoList = [];
            } else if (mode == 'Add') {
                let params = {
                    ser_id: this.serviceInData['ser_id'],
                    model_id: this.servicegriddata['model_id'],
                    name: this.servicegriddata['prod_name'],
                    qty: this.servicegriddata['qty'],
                    rate: this.servicegriddata['rate'],
                    amount: this.servicegriddata['amount']
                },
                    testDet = Object.assign({}, this.servicegriddata);

                // this.serviceEntryService
                //     .addServiceWalkIn(params)
                //     .then(function(res: any) {
                //         that.isLoading = false;
                //
                //         if (res.success) {
                //             swal('SUCCESS', res.message, 'success');
                //
                //             that.salesBillentryDetails.push(testDet);
                //             that.servicegriddata = [];
                //
                //             that.page.count = that.salesBillentryDetails.length;
                //
                //           that.calGrossTotal();
                //            // that.getServiceWalkInList();
                //         } else {
                //             swal('ERROR', res.message, 'error');
                //         }
                //     })
            }
        }



    }

    calAmount() {
        let qty = this.servicegriddata['qty'],
            rte = this.servicegriddata['rate'],
            amt = 0;

        if (!_.isEmpty(_.toString(rte))) {
            amt = (qty * rte);
        }
        this.servicegriddata['amount'] = amt;
    }
    calGrossTotal() {
        let grand_total = 0;

        for (let i = 0; i < this.salesBillentryDetails.length; i++) {
            let amount = this.salesBillentryDetails[i].amount;
            grand_total += Number(amount);
        }
        /*
                let   discount = this.serviceInData['discount'];

                if(!_.isEmpty(_.toString(discount))){
                    grand_total = Number( discount) + grand_total;
                }*/

        this.serviceInData['grand_total'] = grand_total;
        // this.calGrantTotal('all');
    }
    onSaveSalesbillentry() {

        let that = this,
            mode = this._params['mode'],
            testingDet = this.salesBillentryDetails.length,
            Branch = this.serviceInData['from_branch'];

        if (_.isEmpty(_.toString(Branch))) {
            swal('WARNING', 'No Branch Selected, <br> Please Add Branch Details');
            return;
        }
        /*if (_.isEmpty(this.serviceInData['description'])) {
            swal('WARNING', 'Please Type Description!!!!');
            return;
        }*/
        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Service Model Details');
            return;
        }
        let testingDate = moment(this.serviceInData['service_dates']).format('YYYY-MM-DD'),
            data = {
                ser_id: this.serviceInData['ser_id'],
                auto_no: this.serviceInData['auto_no'],
                warranty: this.serviceInData['warranty'],
                branch_id: this.serviceInData['from_branch'],
                date: testingDate,
                client_id: this.serviceInData['client_id'],
                description: this.serviceInData['description'],
                walk_in_type: this.serviceInData['walk_in_type'],
                discount: this.serviceInData['discount'],
                grand_total: this.serviceInData['grand_total'],
                mode: this._params['mode'],
                tabParams: this._params['tabParams'],
                salesBillentryDetails: JSON.stringify(this.salesBillentryDetails),
                sparedet: JSON.stringify(this.spareData)

            };

        this.isLoading = true;

        this.serviceWalkInService
            .saveServiceDetails(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadServiceTestGrid();
                    that.serviceInData = [];
                    that.salesBillentryDetails = [];
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

    onSaveManufactureIn() {

        let that = this,
            mode = this._params['mode'],
            testingDet = this.salesBillentryDetails.length,
            Branch = this.serviceInData['from_branch'];

        if (_.isEmpty(_.toString(Branch))) {
            swal('WARNING', 'No Branch Selected, <br> Please Add Branch Details');
            return;
        }
        /*if (_.isEmpty(this.serviceInData['description'])) {
            swal('WARNING', 'Please Type Description!!!!');
            return;
        }*/
        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Service Model Details');
            return;
        }
        let testingDate = moment(this.serviceInData['service_dates']).format('YYYY-MM-DD'),
            data = {
                ser_id: this.serviceInData['ser_id'],
                auto_no: this.serviceInData['auto_no'],
                warranty: this.serviceInData['warranty'],
                branch_id: this.serviceInData['from_branch'],
                date: testingDate,
                client_id: this.serviceInData['client_id'],
                manufacture_receiptNo: this.serviceInData['manufacture_receiptNo'],
                description: this.serviceInData['description'],
                discount: this.serviceInData['discount'],
                grand_total: this.serviceInData['grand_total'],
                mode: this._params['mode'],
                tabParams: this._params['tabParams'],
                salesBillentryDetails: JSON.stringify(this.salesBillentryDetails),
                sparedet:JSON.stringify(this.spareData)
            };

        this.isLoading = true;

        this.serviceWalkInService
            .saveManufactureIn(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subScribeDeleteActiveTab();
                    that.subscribeService.subReloadServiceTestGrid();
                    that.serviceInData = [];
                    that.salesBillentryDetails = [];
                } else {
                    swal('ERROR', res.message, 'error');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }
    getModelList() {
        let param = {
            type: 'Spare',
            comp_stock: 'no'
        }
        let that = this
        that.commonService
            .getStockModelList(param)
            .then(function (res: any) {
                that.modelList = res.data;
            })
    }
    addSpareEntry() {
        let name = _.find(this.modelList, { 'model_id': this.sparedet.model_id });
        this.sparedet['name']=name.name;
        this.spareData.push(Object.assign({},this.sparedet));
    }

    loadSerialNumber(): void {
        let that = this,
            data = {
                branch_id: that.serviceInData['from_branch'],
                model_id: that.servicegriddata['model_id'],
            };
        this.commonService
            .getSerialNumberList(data)
            .then(function (res: any) {
                // if (res.length > 0) {
                that.serialNumberList = res;
                // } else {
                //     var toast = {
                //         type: 'error',
                //         title: 'ERROR',
                //         body: 'Serial number not available for this Model in this branch,please enter it...'
                //     };
                //     that.toasterService.pop(toast);
                // }
            });
    }

    onChangeSerial(sno: any) {
        let that = this;
        let fitem = _.find(this.serialNumberList, sno);
        that.servicegriddata['serial_no'] = fitem['serialNO'];
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/testingTrail/addServiceEntry.component.ts